export default "__VITE_ASSET__CSWLS6_y__"